export default __webpack_public_path__ + "assets/images/463368a5d9ba2366d8f27d9809a0c535.svg";